import { getRoot, Instance, types } from 'mobx-state-tree';
import { ComponentModel } from '../../ui/ComponentModel';
import { PaginationModel } from '../../ui/pagination/PaginationModel';
import { RootType } from '../../../rootInstance';
import {
  NewsletterListElementModel,
  NewsletterListElementModelType,
} from './NewsletterListElementModel';

export const NewsletterTableModel = types
  .compose(
    ComponentModel,
    types.model({
      pagination: types.maybe(types.late(() => PaginationModel)),
      rows: types.array(NewsletterListElementModel),
    })
  )
  .views((self) => {
    return {
      get root(): RootType {
        return getRoot(self);
      },
      get elements() {
        return Array.from(self.rows.values());
      },
    };
  })
  .actions((self) => {
    return {
      clearElements() {
        self.rows = [];
      },
      setElements(newsletterArray: NewsletterListElementModelType[]) {
        self.clearElements();
        newsletterArray.forEach(
          (newsletterElement: NewsletterListElementModelType) => {
            self.rows?.push(newsletterElement);
          }
        );
      },
    };
  })
  .named('NewsletterTableModel');

export type NewsletterTableModelType = Instance<typeof NewsletterTableModel>;
